
import AccountUnlocking from "../Authentication/AccountUnlocking";

const AccountUnlockingRoute = props => <AccountUnlocking {...props} />;

export default AccountUnlockingRoute;
